import { css } from "styled-components";

/*
 * Набор стилей для заимствования в styled-components
 * @TODO по мере продвижения предлагаю выносить всё в подобные файлы, далее styled-components собирать просто из них
 *
 * */

export const configButtonStyles = css`
    .settings__header-button,
    .contacts__button.main {
        padding: 0;
    }

    .settings__header-buttons {
        gap: 10px;
    }

    .settings__header-buttons .settings__header-button {
        padding: 10px;
        border: 1px solid #4c89fe;
    }

    .settings__header-button.active {
        background-color: #3c6ce6;
        border: 1px solid transparent;
        color: white;
    }

    .config__button {
        width: fit-content;
        margin: 0;
        padding: 11px 24px;
    }

    .config__button.transparent {
        padding: 0;
    }
`;

export const inheritRowStyles = css`
    .settings__input-container {
        margin: 0;
    }

    &.settings__header-container {
        align-items: start;
        gap: 24px;
    }

    &.profile__with-gap {
        gap: 14px;
    }

    .settings__header-button {
        margin: 0;
        padding: 0;
    }
`;

export const inheritHeaderStyles = css`
    position: relative;
    display: flex;
    align-items: center;

    &.header__container {
        align-items: start;
    }

    .header__search {
        cursor: pointer;
        height: 1em;
        padding: 0;
        margin: 0;
        background: none;
        border: 1px solid transparent;
        outline: none;

        > * {
            height: 100%;
        }
    }

    /*
    .style6 {
        position: relative;
        padding: 5px 25px;
        margin: 0;
    }
    */
`;

export const inheritHeaderButtonStyles = css`
    &.periods__buttons-list {
        width: 300px;
    }

    .button__header-tab {
        width: fit-content;
        padding: 0 16px;
    }

    button {
        display: inline-block;
        border-radius: 8px;
        width: 37%;
        color: #4c89fe;

        font-size: 14px;
        font-style: normal;
        font-weight: 700;

        &.active {
            color: white;
            background: var(--dark-bgbg-page, #262732);
        }
    }
`;

export const inheritTabWidthStyles = css`
    /*
    width: 1380px;

    @media screen and (max-width: 1930px) {
        width: 1080px;

        &.top {
            width: 448px;

            button {
                width: 75px;
            }
        }
    }
    
     */
`;

export const inheritContainerStyles = css`
    background: #2b2d39;
    padding: 0;
    color: #e9e9ea;
    border-radius: 16px;
    margin-bottom: 16px;
    width: 100%;

    &.container__grid {
        background: #2b2d39;
        color: #e9e9ea;
        border-radius: 16px;
        margin-bottom: 16px;
        width: 100%;
        min-height: 300px;
        grid-column: 1;
        grid-row: 1;
        display: grid;
    }

    &.container__resources-page {
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding: 0;
        margin: 0;

        width: 100%;
        min-width: unset;

        .container__resources-row-wrapper {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            &.row__with-gap > *,
            &.row__with-gap {
                gap: 24px;
            }
        }

        .profile__resources-scroll-wrapper {
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
            padding-bottom: 10px;

            height: 100%;
        }

        .container__resources-grid-wrapper {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
        }
    }

    &.container__flex {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .item {
        border-top: 1px solid #3a3b47;
        padding: 10px 0;
        border-radius: 4px;
        width: calc(100% - 45px);
        display: inline-block;

        .avatar {
            display: inline-block;
            position: relative;
        }

        .name {
            cursor: pointer;
            display: inline-block;
            padding: 0 20px;
            position: relative;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    &.container__refusal-reasons {
        padding: 0;
        margin: 0;

        display: flex;
        flex-direction: column;
        gap: 24px;

        .settings__header-button {
            margin: 0;
            padding: 11px 24px;

            width: fit-content;
        }
    }
`;

export const configGridStyles = css`
    &.resources__items-grid,
    .resources__items-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 16px 24px;
    }

    .resources__item {
        width: 100%;
        max-width: unset;
        min-width: unset;
    }

    @media screen and (max-width: 1440px) {
        .resources__items-grid {
            grid-template-columns: repeat(3, 1fr);
        }
    }

    @media screen and (max-width: 1280px) {
        .resources__items-grid {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media screen and (max-width: 1024px) {
        .resources__items-grid {
            grid-template-columns: repeat(1, 1fr);
        }
    }
`;

export const headerDropdownStyles = css``;
